import { defineComponent as _defineComponent } from 'vue'
import { computed, useContext, useRouter, useStore } from '@nuxtjs/composition-api';
import WarRoomConfirmHideComment from '@/components/partials/war-room/WarRoomConfirmHideComment.vue';
import WarRoomConfirmRemoveComment from '@/components/partials/war-room/WarRoomConfirmRemoveComment.vue';
import WarRoomDealStoryPostHeader from '@/components/partials/war-room/WarRoomDeal/WarRoomDealStoryPostHeader.vue';
import WarRoomPostAuthor from '@/components/partials/war-room/WarRoomPostAuthor.vue';
import WarRoomPostContent from '@/components/partials/war-room/WarRoomPostContent/WarRoomPostContent.vue';
import WarRoomPostFilesAttached from '@/components/partials/war-room/WarRoomPostFilesAttached.vue';
import WarRoomPostOfficialHeader from '@/components/partials/war-room/WarRoomPostOfficialHeader/WarRoomPostOfficialHeader.vue';
import WarRoomPostPoll from '@/components/partials/war-room/WarRoomPostPoll/WarRoomPostPoll.vue';
import WarRoomPostTopics from '@/components/partials/war-room/WarRoomPostTopics.vue';
import WarRoomPostVote from '@/components/partials/war-room/WarRoomVote/WarRoomPostVote.vue';
import WarRoomSchema from '@/components/partials/war-room/WarRoomSchema/WarRoomSchema.vue';
import WarRoomShare from '@/components/partials/war-room/WarRoomShare/WarRoomShare.vue';
import WarRoomUserSelector from '@/components/partials/war-room/WarRoomUserSelector.vue';
import { makeUrl } from '@/components/utils/browser/url';
import { sharableTypes } from '@/components/partials/war-room/WarRoomShare/constants';
import { categoryNames } from '@/components/partials/war-room/WarRoomPostForm/WarRoomPostFormCategories/constants';
import { isPostContentADealStory } from '@/types/typeHelpers';
import type { IPost } from '@/types/community';
import { SIGN_UP_MODAL } from '~/constants';
import type { RootState } from '~/types/store';

type WarRoomPostProps = {
  post: IPost;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'WarRoomPost',
  props: {
    post: null
  },
  setup(__props: any) {

const props = __props as {
  post: IPost;
};



const { $auth, $modal, $analytics, $sentryUtils, $notice } = useContext();
const router = useRouter();
const store = useStore<RootState>();

const sharableType = sharableTypes.POST;

const topics = computed(() => props.post.topic_ids.map(id => store.state.warRoom.topic_dict[id]));
const isAuthor = computed(() => (props.post.author ? props.post.user_username === $auth.user?.username : false));
const isDealStory = computed(() => props.post.category.slug === categoryNames.WIN_WIRE);
const dealCompany = computed(() =>
  isPostContentADealStory(props.post.content.data) && props.post.content.data.deal.company
    ? props.post.content.data.deal.company.name
    : undefined,
);
const dealDepartments = computed(() =>
  isPostContentADealStory(props.post.content.data)
    ? props.post.content.data.deal.departments?.map(d => d.name) || []
    : [],
);
const sharableUrl = computed(() =>
  makeUrl(
    router.resolve({
      name: 'war-room-posts-postSlug',
      params: { postSlug: props.post.slug },
    }).href,
  ),
);

async function onPollVote(choiceId: number) {
  if (!$auth?.loggedIn) {
    $modal.show(SIGN_UP_MODAL);
    return;
  }

  try {
    $analytics?.logEvent('war-room__post__poll-choice__click', { choiceId });

    await store.dispatch('warRoom/addPollChoice', { postSlug: props.post.slug, choiceId });
  } catch (e) {
    if (e instanceof Error) {
      $notice.error(e);
    }
    $sentryUtils.error(e);
  }
}

return { __sfc: true,props, $auth, $modal, $analytics, $sentryUtils, $notice, router, store, sharableType, topics, isAuthor, isDealStory, dealCompany, dealDepartments, sharableUrl, onPollVote, WarRoomConfirmHideComment, WarRoomConfirmRemoveComment, WarRoomDealStoryPostHeader, WarRoomPostAuthor, WarRoomPostContent, WarRoomPostFilesAttached, WarRoomPostOfficialHeader, WarRoomPostPoll, WarRoomPostTopics, WarRoomPostVote, WarRoomSchema, WarRoomShare, WarRoomUserSelector }
}

})